import React from 'react';
import styled from 'styled-components';

const TitleContainer = styled.div`
  text-align: ${props => props.center ? 'center' : 'left'};
  margin-bottom: 3rem;
  position: relative;
  z-index: 1;
  
  &::before {
    content: '';
    position: absolute;
    width: 150px;
    height: 150px;
    background: radial-gradient(circle, rgba(0, 213, 146, 0.12) 0%, transparent 70%);
    border-radius: 50%;
    z-index: -1;
    top: -50px;
    ${props => props.center ? 'left: 50%; transform: translateX(-50%);' : 'left: -50px;'}
  }
`;

const Subtitle = styled.h5`
  color: ${props => props.theme.colors.primary};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 1.2rem;
  font-size: 0.95rem;
  display: block;
  position: relative;
  padding-left: ${props => props.center ? '0' : '25px'};
  
  &::before {
    content: '//';
    position: absolute;
    left: ${props => props.center ? '0' : '0'};
    top: 0;
    color: ${props => props.theme.colors.primary};
    opacity: 0.7;
    font-weight: 500;
    
    ${props => props.center && `
      position: relative;
      margin-right: 10px;
      display: inline-block;
      
      @media (max-width: ${props.theme.breakpoints.sm}) {
        display: none;
      }
    `}
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: ${props => props.center ? '25%' : '0'};
    width: ${props => props.center ? '50%' : '100%'};
    height: 2px;
    background: linear-gradient(
      90deg,
      ${props => props.theme.colors.primary} 0%,
      rgba(0, 213, 146, 0.2) 100%
    );
    border-radius: 2px;
  }
`;

const Title = styled.h2`
  color: ${props => props.theme.colors.secondary};
  font-size: 2.8rem;
  margin-bottom: 1.5rem;
  font-weight: 800;
  letter-spacing: -0.5px;
  position: relative;
  display: block;
  width: 100%;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: ${props => props.center ? '25%' : '0'};
    width: ${props => props.center ? '50%' : '80px'};
    height: 4px;
    background: ${props => props.theme.colors.primary};
    border-radius: 4px;
    opacity: 0.3;
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: 2.2rem;
  }
`;

const Description = styled.p`
  color: ${props => props.theme.colors.gray};
  font-size: 1.2rem;
  line-height: 1.7;
  max-width: ${props => props.center ? '800px' : '100%'};
  margin: ${props => props.center ? '0 auto' : '0'};
  position: relative;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: 1.1rem;
  }
`;

const SectionTitle = ({ subtitle, title, description, center }) => {
  return (
    <TitleContainer center={center}>
      {subtitle && <Subtitle center={center}>{subtitle}</Subtitle>}
      {title && <Title center={center}>{title}</Title>}
      {description && <Description center={center}>{description}</Description>}
    </TitleContainer>
  );
};

export default SectionTitle;